<div class="mediaContainer row m-1 p-1 h-100">
  <q-list-media class="list-media" [medias]="medias" [restrictedTo]="restrictedTo" [filter]="filter" (selectMedia)="selectMedia($event)" (updateMedia)="changeUpdateMedia($event)" [detectChangeNewMedia]="detectChangeNewMedia"></q-list-media>
  <q-new-media class="new-media" (newMedia)="addMedia($event)" [restrictedTo]="restrictedTo" [updateMedia]="updateMedia" (resetMedia)="changeUpdateMedia($event)"></q-new-media>
</div>
